import { useField } from 'formik';
import {
  Switch,
  FormControl,
  SwitchProps,
  FormHelperText,
  FormControlLabel,
} from '@mui/material';

import { controlError } from 'utils/error';

export interface SwitchFieldProps extends Omit<
  SwitchProps,
  'name' | 'onChange'
> {
  name: string;
  label?: string;
  controlErrorLabel?: boolean;
  formatFieldValue?: (value: boolean) => any;
  formatRenderValue?: (value: any) => boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

export function SwitchField({
  name,
  label,
  onChange,
  formatFieldValue,
  formatRenderValue,
  ...props
}: SwitchFieldProps) {
  const [field, meta, helpers] = useField(name);

  const errorText = controlError(meta, name, label);
  const hasError = Boolean(errorText);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    helpers.setValue(formatFieldValue ? formatFieldValue(value) : value);
    onChange?.(event, value);
  };

  return (
    <FormControl error={hasError}>
      <FormControlLabel
        label={label}
        control={
          <Switch
            {...props}
            name={field.name}
            onChange={handleChange}
            checked={
              formatRenderValue
                ? formatRenderValue(field.value)
                : Boolean(field.value)
            }
          />
        }
      />
      {hasError && (
        <FormHelperText className="!ml-0">{errorText}</FormHelperText>
      )}
    </FormControl>
  );
}
